import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { ServerMediaAsset } from '@/lib/janitsjar/Product';

type ProductImageProps = {
  media: ServerMediaAsset;
};

export default function ProductImage({ media }: ProductImageProps) {
  return (
    <div className="w-full h-full p-6 pt-0 md:p-12">
      <div className="relative w-full h-full bg-neutral-30">
        <Image
          src={media.url}
          alt="Carousel image"
          fill
          className={twMerge(
            clsx('object-contain mix-blend-darken', {
              'p-24': media.url === '/no_image.svg',
            })
          )}
        />
      </div>
    </div>
  );
}
